import styled from 'styled-components/macro';
import { Button } from 'ui-component-library';

import { FlexAlignRight, FlexJustifyCenter } from '../../../../shared-styles/flex';
import { InfoSectionHeaderButton, InfoSectionHeaderButtonContainer } from '../../../../shared-styles/info-section-header-button';

export const TmsLinkContainer = styled.div`
  ${FlexAlignRight}
  padding-bottom: ${(props) => props.theme.spacing(20)};
  padding-right: ${(props) => props.theme.spacing(20)};
`;

export const HeaderButtonsGroup = styled.div`
  ${InfoSectionHeaderButtonContainer}
`;

export const HeaderButton = styled(Button)`
  ${InfoSectionHeaderButton}
`;

export const LoadingContainer = styled.div`
  ${FlexJustifyCenter}
  width: 540px;
`;

export const EquipmentEditMessage = styled.p`
  margin-bottom: ${(props) => props.theme.spacing(10)};
`;
